<template>
  <v-container class="mt-2">
    <v-card
      class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Cobertura - Editar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="update">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader v-if="!coverage" type="article, actions" />

      <v-container fluid>
        <CoverageForm ref="form" :typeForm="'new'" :errors="errors" :coverage="coverage" v-if="coverage"></CoverageForm>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import CoverageForm from "@/components/coverage/coverage_form.vue"
import { mapErrors } from "@/common/validation"
import { mapActions, mapMutations } from "vuex";

export default {
  components: { CoverageForm },
  data() {
    return {
      errors: {},
      coverage: null
    };
  },
  async created() {
    this.coverage = await this.fetchCoverage(this.$route.params.id);
    this.coverage.is_ans_coverage = this.coverage.ansCoverage;
    this.coverage.is_executive_differential = this.coverage.executiveDifferential;
    this.isLoading = false;
  },
  methods: {
    ...mapActions("coverage", ["fetchCoverage", "updateCoverage"]),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    update() {
      if(!this.$refs.form.validate()) {
        this.showmsg({text: 'Por favor, preencha os campos obrigatórios.', type: 'warning'});
        return;
      }
      
      this.toogleDialogLoading(true);
      this.errors = {}
      const formModel = this.$refs.form.model();
      let payload = { ...formModel };
      payload.record_type_id = {
        id: formModel.recordTypeId,
      };

      payload.coverage_description_id = {
        id: formModel.descriptionId,
      };

      payload.coverage_group_id = {
        id: formModel.groupId,
      };
      
      this.updateCoverage({id: this.coverage.id, coverage: payload}).then(() => {
        this.$router.push(`/coverage/${this.coverage.id}/show`)
      }).catch((error) => {
        const { errors } = error.response.data;
        this.errors = mapErrors(this.$refs.form.model(), errors)
      }).finally(() => {
        this.toogleDialogLoading(false);
      });
    }
  },
};
</script>


